/**
 * Accessible TMenu Enhancer — a11y-compliant version
 *
 * Fixes:
 *  1. Moves the submenu toggle OUT of the <a> (it's a sibling <button> now).
 *  2. Removes aria-hidden from the indicator.
 *  3. Uses a UNIQUE aria-label per item based on the item's text.
 */
(function () {
  'use strict';

  const MENU_SELECTORS = ['.tmenu_nav', '.menu-drawer__list'];
  const ROOT_SELECTOR = '.tmenu_item';
  const ACTIVE_CLASS = 'hover';
  const MAX_RETRIES = 30;
  const INITIAL_DELAY = 400;

  // Fix button styles
  const style = document.createElement('style');
  style.textContent = `
    .tmenu_indicator--a11y {
      background: none !important;
      border: none !important;
      padding: 0 !important;
      margin: 0 !important;
      cursor: pointer !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      position: static !important;
      vertical-align: middle !important;
      flex-direction: row !important;
    }

    .tmenu_item_link + .tmenu_indicator--a11y {
      display: inline-flex !important;
    }

    .tmenu_item_link:has(+ .tmenu_indicator--a11y) {
      display: inline-flex !important;
      vertical-align: middle !important;
    }

    .tmenu_item--root > .tmenu_item_link:has(+ .tmenu_indicator--a11y) {
      display: inline-flex !important;
      vertical-align: middle !important;
    }
  `;
  style.className = 'a11y-menu-fix';
  document.head.appendChild(style);

  function getItemText(item) {
    const textEl = item.querySelector(':scope > a .tmenu_item_text');
    return (textEl?.innerText || textEl?.textContent || '').trim();
  }

  function dispatchMouse(el, types) {
    types.forEach((type) =>
      el.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true }))
    );
  }

  function openSubmenu(item, button) {
    item.classList.add(ACTIVE_CLASS);
    item.setAttribute('data-open', 'true');
    button.setAttribute('aria-expanded', 'true');
    dispatchMouse(item, ['mouseenter', 'mouseover']);
  }

  function closeSubmenu(item, button) {
    item.classList.remove(ACTIVE_CLASS);
    item.setAttribute('data-open', 'false');
    button.setAttribute('aria-expanded', 'false');
    dispatchMouse(item, ['mouseleave', 'mouseout']);
  }

  function shouldCreateButton(item, isMobile) {
    if (isMobile) {
      // Mobile: verify submenu exists in DOM
      return !!item.querySelector(':scope > .tmenu_submenu, :scope > ul');
    } else {
      // Desktop: use tmenu_item_has_child class
      return item.classList.contains('tmenu_item_has_child');
    }
  }

  function enhanceItem(item, isMobile) {
    if (item.dataset.a11yEnhanced === 'true') return;

    const link = item.querySelector(':scope > a.tmenu_item_link');
    if (!link) return;

    if (!shouldCreateButton(item, isMobile)) {
      item.dataset.a11yEnhanced = 'true';
      return;
    }

    const itemText = getItemText(item) || 'menu';
    const oldIndicator = link.querySelector('.tmenu_indicator');

    // Create a proper <button> to replace the span
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'tmenu_indicator--a11y';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', `Toggle submenu for ${itemText}`);

    // Keep the original visual icon, if any
    if (oldIndicator) {
      button.innerHTML = oldIndicator.innerHTML;
      button.removeAttribute('aria-hidden');
      // Remove the old span and replace it with the button
      oldIndicator.remove();
    }

    // Insert button AFTER the link (as a sibling, NOT nested inside <a>)
    link.insertAdjacentElement('afterend', button);

    item.dataset.a11yEnhanced = 'true';
    item.setAttribute('data-open', 'false');

    // Clean stray aria from the link itself
    link.removeAttribute('role');
    link.removeAttribute('aria-expanded');
    link.removeAttribute('aria-haspopup');

    // Click toggles the submenu
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = item.getAttribute('data-open') === 'true';
      if (isOpen) closeSubmenu(item, button);
      else openSubmenu(item, button);
    });

    // Close on focusout of the whole <li>
    item.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!item.contains(document.activeElement)) closeSubmenu(item, button);
      }, 10);
    });
  }

  function enhanceMenu() {
    let enhanced = false;
    MENU_SELECTORS.forEach(selector => {
      const menu = document.querySelector(selector);
      if (!menu) return;
      const items = menu.querySelectorAll(ROOT_SELECTOR + '.tmenu_item_level_0');
      if (!items.length) return;
      const isMobile = selector === '.menu-drawer__list';
      items.forEach(item => enhanceItem(item, isMobile));
      enhanced = true;
    });
    return enhanced;
  }

  function waitForMenu(attempt = 1, delay = INITIAL_DELAY) {
    const hasMenu = MENU_SELECTORS.some(selector => document.querySelector(selector));
    const hasItems = document.querySelectorAll(ROOT_SELECTOR).length > 0;

    if (hasMenu && hasItems) {
      enhanceMenu();
      // Handle TMenu re-renders
      new MutationObserver(() => enhanceMenu()).observe(document.body, {
        childList: true,
        subtree: true,
      });
      return;
    }
    if (attempt >= MAX_RETRIES) return;
    setTimeout(() => waitForMenu(attempt + 1, delay * 1.25), delay);
  }

  waitForMenu();
})();

function removeComments(element) {
  const iterator = document.createNodeIterator(
    element,
    NodeFilter.SHOW_COMMENT,
    null,
    false
  );

  let currentNode;
  while ((currentNode = iterator.nextNode())) {
    currentNode.remove();
  }
}

const headings = document.querySelectorAll('.card-collection__heading');

headings.forEach(heading => {
  removeComments(heading);
});

window.addEventListener('DOMContentLoaded', function () {
  const ORIGINAL_LABEL = 'Instagram post opens in a popup';

  setInterval(() => {
    const items = document.querySelectorAll('.instafeed-new-layout-item-container');

    items.forEach((item, index) => {
      const link = item;

      const wrapper = item.closest('.instafeed-new-layout-item');
      if (!wrapper) {
        return;
      }

      const img = wrapper.querySelector('img[alt]');
      if (!img) {
        return;
      }

      const currentLabel = link.getAttribute('aria-label');

      if (currentLabel && currentLabel !== ORIGINAL_LABEL) {
        return;
      }

      const altText = img.getAttribute('alt')?.trim();

      if (altText) {
        link.setAttribute('aria-label', altText);
      } else {
        const fallback = `Open Instagram post ${index + 1} in a dialog`;
        link.setAttribute('aria-label', fallback);
      }
    });
  }, 1000);

  document.addEventListener('focusin', (event) => {
  const el = event.target;

  console.log(
    '[Focus]',
    el,
    'tag:',
    el.tagName,
    'classes:',
    el.className,
    'aria-label:',
    el.getAttribute('aria-label')
  );
});

setInterval(() => {
  document.querySelectorAll('.yotpo-custom-step-icon').forEach(img => {
    if (img.hasAttribute('alt')) {
      img.removeAttribute('alt');
      console.log('[Yotpo A11y] alt removed', img);
    }
  });
}, 1000);
setInterval(() => {
  document.querySelectorAll('.yotpo-vip-tier-icon').forEach(img => {
    if (img.hasAttribute('alt')) {
      img.removeAttribute('alt');
      console.log('[Yotpo A11y] alt removed', img);
    }
  });
}, 1000);

setInterval(() => {
  document.querySelectorAll('.yotpo-outer-tile[role="listitem"]').forEach(tile => {
    if (tile.getAttribute('role') !== 'button') {
      tile.setAttribute('role', 'button');

      tile.setAttribute('tabindex', '0');

      if (!tile.hasAttribute('aria-label') || tile.getAttribute('aria-label').trim() === '') {
        const campaignName = tile.getAttribute('aria-label') || 'Earn Points Campaign';
        tile.setAttribute('aria-label', campaignName);
      }

      tile.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          tile.click();
        }
      });

      console.log('[Yotpo Accessibility] Tile converted to button:', tile);
    }
  });
}, 1000);

const interval = setInterval(() => {
  const table = document.querySelector('.collapsible__content table');
  if (!table) return;

  clearInterval(interval);

  const colgroup = table.querySelector("colgroup");
  if (colgroup) colgroup.remove();

  const rows = table.rows;
  if (rows.length === 0) return;

  const firstRow = rows[0];
  for (let i = 0; i < firstRow.cells.length; i++) {
    const cell = firstRow.cells[i];
    const th = document.createElement("th");
    th.innerHTML = cell.innerHTML;
    th.className = cell.className;
    th.scope = "col";
    firstRow.replaceChild(th, cell);
  }

  for (let r = 1; r < rows.length; r++) {
    const row = rows[r];
    const cell = row.cells[0];
    const th = document.createElement("th");
    th.innerHTML = cell.innerHTML;
    th.scope = "row";
    th.style.width = "auto";
    th.style.height = "auto";
    th.className = "";
    row.replaceChild(th, cell);
  }


}, 100);


});

document.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelectorAll('.slideshow__slide');
  const totalSlides = slides.length;

  slides.forEach((slide, index) => {
    const img = slide.querySelector('img');
    if (!img) return;

    const altText = img.getAttribute('alt')?.trim();
    if (!altText) return;

    const slideNumber = index + 1;

    slide.setAttribute(
      'aria-label',
      `Slide ${slideNumber} of ${totalSlides}: ${altText}`
    );
  });
});

document.addEventListener('DOMContentLoaded', () => {

  function updateSelectedSwatchAria() {
    document.querySelectorAll('.color-swatch').forEach(swatch => {
      swatch.removeAttribute('aria-current');
    });

    const selectedItem = document.querySelector('.color-swatch__item.selected');
    if (!selectedItem) return;

    const selectedSwatch = selectedItem.closest('.color-swatch');
    if (selectedSwatch) {
      selectedSwatch.setAttribute('aria-current', 'page');
    }
  }

  updateSelectedSwatchAria();

  const swatchContainer = document.querySelector('.color-swatch-list');
  if (!swatchContainer) return;

  const observer = new MutationObserver(() => {
    updateSelectedSwatchAria();
  });

  observer.observe(swatchContainer, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

});

document.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    const buttons = document.querySelectorAll('.yotpo-star-distribution button');
    if (buttons.length > 0) {
      buttons.forEach(button => {
        button.setAttribute('role', 'link');

        if (!button.querySelector('.visually-hidden')) {
          const hiddenText = document.createElement('span');
          hiddenText.className = 'visually-hidden';

          const match = button.getAttribute('aria-label')?.match(/(\d+) star review by (\d+) users/);
          if (match) {
            const stars = match[1];
            const users = match[2];
            hiddenText.textContent = `Selecting this will show the ${users} reviews for ${stars} star rating`;
            button.appendChild(hiddenText);
          }
        }
      });

      clearInterval(interval);
    }
  }, 500);

  if (!document.querySelector('.visually-hidden-style')) {
    const style = document.createElement('style');
    style.textContent = `
      .visually-hidden {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0 0 0 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
      }
    `;
    style.className = 'visually-hidden-style';
    document.head.appendChild(style);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    const dialog = document.querySelector('.cart-drawer .dialog');

    if (!dialog || !dialog.hasAttribute('open')) return;

    const cartTitle = dialog.querySelector('#cart-drawer-heading');
    if (cartTitle && !cartTitle.dataset.focused) {
      cartTitle.setAttribute('tabindex', '-1');
      cartTitle.focus();
      cartTitle.dataset.focused = 'true';
    }

    const thumbnails = dialog.querySelectorAll('.cart-item__product-image a');
    thumbnails.forEach((thumb, index) => {
      if (!thumb.dataset.a11yEnhanced) {
        const productName = thumb.querySelector('.visually-hidden')?.textContent || `Product ${index+1}`;
        thumb.setAttribute('aria-label', `Load image ${index + 1} in gallery view for ${productName}`);
        thumb.dataset.a11yEnhanced = 'true';
      }
    });

    let liveRegion = dialog.querySelector('[data-live-region]');
    if (!liveRegion) {
      liveRegion = document.createElement('span');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('data-live-region', '');
      liveRegion.className = 'visually-hidden';
      dialog.appendChild(liveRegion);
    }

    const mainImages = dialog.querySelectorAll('.cart-item__product-image img');
    mainImages.forEach((img, idx) => {
      if (!img.dataset.liveObserved) {
        let lastSrc = img.src;
        setInterval(() => {
          if (img.src !== lastSrc) {
            lastSrc = img.src;
            liveRegion.textContent = `Image ${idx + 1} displayed`;
          }
        }, 200);
        img.dataset.liveObserved = 'true';
      }
    });

    clearInterval(interval);
  }, 300);

});

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.querySelector("img.shopify-dns-link-icon").remove();
    document.querySelectorAll('.tmenu_item_link[aria-haspopup]')
    .forEach(link => {
      link.removeAttribute('aria-expanded');
      link.removeAttribute('aria-haspopup');
      link.removeAttribute('role');
    });

  }, 1000);

  setTimeout(() => {
    document.querySelectorAll('.slider-component__item').forEach(item => {
      const imageLink = item.querySelector('.expand-link__link');
      const titleLink = item.querySelector('h3 a');

      if (!imageLink && !titleLink) return;

      const href = imageLink?.getAttribute('href') || titleLink?.getAttribute('href');
      if (!href) return;

      const wrapper = document.createElement('a');
      wrapper.href = href;
      wrapper.className = 'card-wrapper-link';

      const label = titleLink?.textContent?.trim();
      if (label) {
        wrapper.setAttribute('aria-label', label);
      }

      while (item.firstChild) {
        wrapper.appendChild(item.firstChild);
      }

      item.appendChild(wrapper);

      wrapper.querySelectorAll('a').forEach(a => {
        if (a !== wrapper) {
          a.replaceWith(...a.childNodes);
        }
      });
    });
  }, 1000);
});

function fixYotpoHeading() {
  const el = document.getElementById('yotpo-headline-reviews');
  if (!el) return;

  if (el.tagName.toLowerCase() === 'h2') return;

  const h2 = document.createElement('h2');

  [...el.attributes].forEach(attr => {
    h2.setAttribute(attr.name, attr.value);
  });

  h2.innerHTML = el.innerHTML;

  el.replaceWith(h2);
}

setTimeout(fixYotpoHeading, 1500);

const interval = setInterval(() => {
  const items = document.querySelectorAll(
    '.tmenu_submenu > li.tmenu_item_level_1.tmenu_item_display_header > a .tmenu_item_text'
  );

  if (items.length === 0) return;

  items.forEach(el => {
    if (el.tagName.toLowerCase() === 'h2') return;

    const h2 = document.createElement('h2');
    h2.className = el.className;
    h2.textContent = el.textContent;

    el.replaceWith(h2);
  });
}, 500);
